import { useFormik, type FormikErrors } from 'formik';
import React from 'react';

import { useTranslation } from 'src/core/common/hooks/useTranslation';

import { DirectionColumnEditModal } from './DirectionColumnEditModal';
import { type DirectionFormValues } from './form';
import {
  type RowDisplayOption,
  type ColumnDisplayOptions,
} from '../../../export';

type Props = {
  isOpen: boolean;
  title: string;
  debit: string;
  credit: string;
  description: string;
  isDeletable: boolean;
  onRemoveColumn: () => void;
  onClose: () => void;
  onSaveColumn: (values: DirectionFormValues) => void;
  rowDisplayOptions?: RowDisplayOption[];
  displayOptions?: ColumnDisplayOptions;
  maxLength?: string;
};

export const DirectionColumnEditModalContainer = ({
  title,
  onSaveColumn,
  debit,
  credit,
  displayOptions,
  maxLength,
  ...rest
}: Props) => {
  const { t } = useTranslation('global');

  const formikProps = useFormik<DirectionFormValues>({
    initialValues: {
      title,
      debit,
      credit,
      displayOptions,
      maxLength,
    },
    validate: (values) => {
      const errors: FormikErrors<DirectionFormValues> = {};

      if (!values.title.trim()) {
        errors.title = t('exports.emptyColumnTitleError');
      }

      if (!values.credit?.trim()) {
        errors.credit = t(
          'bookkeep.settings.export.directionOptions.emptyError',
        );
      }

      if (!values.debit?.trim()) {
        errors.debit = t(
          'bookkeep.settings.export.directionOptions.emptyError',
        );
      }

      return errors;
    },
    onSubmit: (values) => {
      onSaveColumn({
        title: values.title,
        debit: values.debit,
        credit: values.credit,
        displayOptions: values.displayOptions,
        maxLength: values.maxLength,
      });
    },
  });

  return <DirectionColumnEditModal title={title} {...rest} {...formikProps} />;
};
